import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked--sprite",
  "use": "checked--sprite-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol viewBox=\"0 0 18 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checked--sprite\">\n<path d=\"M16 0.439453H2C0.89 0.439453 0 1.33945 0 2.43945V16.4395C0 17.5395 0.89 18.4395 2 18.4395H16C17.11 18.4395 18 17.5395 18 16.4395V2.43945C18 1.33945 17.11 0.439453 16 0.439453ZM7 14.4395L2 9.43945L3.41 8.02945L7 11.6095L14.59 4.01945L16 5.43945L7 14.4395Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol